var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('Header',{attrs:{"active":_vm.active,"cardArr":_vm.cardArr},on:{"changePackage":_vm.changePackage}}),_c('Content',{attrs:{"active":_vm.active,"cardArr":_vm.cardArr}}),(_vm.isMember)?_c('Footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }